<style src="./ColumnResult.scss"lang="scss"></style>
<template>
  <li
    class="result box">
    <div
      v-if="status"
      class="spinner">
      <icon-wait class="icon" />
    </div>

    <template v-if="!editMode">
      <div
        v-if="!haveResult"
        class="editmode">
        <button
          @click="enterEditMode"
          class="cp1-small-button cp1-button__warning">
          INSERIR RESULTADO
        </button>
      </div>
      <div
        v-if="haveResult"
        @click="enterEditMode"
        class="informations">
        <div class="description">
          <span class="title title__dist">DISTRIBUIDOR</span>
          <span class="value">{{ distributor }}</span>
          <span class="title title__lab">LABORATÓRIO</span>
          <span class="value">{{ lab }}</span>
        </div>
        <div class="values">
          <span class="title">VALOR OFERTADO</span>
          <div class="cost">
            <small class="currency">R$</small>
            <span>{{ offer | CurrencyBR('', 4) }}</span>
          </div>
          <span class="total">
            <small class="currency">R$</small>
            {{ calculatedTotal | CurrencyBR }}
            <small class="perc">{{ calculatedPerc }}%</small>
          </span>
        </div>
      </div>
    </template>

    <template v-if="editMode">
      <form
        v-shortkey="['esc']"
        @shortkey="escapeFromEdition"
        @submit.prevent="saveResult"
        :class="{ 'result__saving': status === 'saving' }"
        class="rowvalues">
        <div class="form">
          <suggest-distribuitor
            label="Distribuidora"
            placeholder="DISTRIBUIDORA"
            v-model="distributor"
            @selected="selectDistributor"
            class="suggest" />
          <suggest-lab
            label="Marca"
            placeholder="MARCA"
            v-model="form.lab"
            class="suggest" />
        
          <moneybox
            class="formoffer"
            label="Valor R$"
            :precision="precision"
            v-model="form.offer" />
        </div>

        <div class="commands">
          <button
            type="button"
            @click="removeResult"
            class="cp1-xsmall-button cp1-button__default">
            R
          </button>
          <button
            type="button"
            @click="escapeFromEdition"
            class="cp1-xsmall-button cp1-button__default">
            CANCELAR
          </button>
          <button
            class="cp1-xsmall-button cp1-button__success">
            SALVAR
          </button>
        </div>
      </form>
    </template>
  </li>
</template>

<script>
import { Moneybox, SuggestDistribuitor, SuggestLab } from '@/components/primitives'
import { IconWait } from '@/components/primitives/icons'
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import SaveResult from '@/brain/result/save-item/SaveItem'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'ColumnResult',
  components: {
    Moneybox,
    SuggestDistribuitor,
    SuggestLab,
    IconWait
  },
  props: {
    position: {
      type: String,
      default: 'winner'
    },
    info: {
      type: Object,
      default: null
    }
  },
  directives: {
    ClickOutside
  },
  data () {
    return {
      editMode: false,
      status: false,
      precision: 4,
      distributor: '',
      lab: '',
      offer: 0,
      form: {
        distributorId: null,
        lab: null,
        offer: 0
      }
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber
  },
  computed: {
    haveResult () {
      return !!this.offer
    },
    calculatedTotal () {
      const offer = this.offer
      return this.info.itemInfo.quantity * offer
    },
    calculatedPerc () {
      const v2 = this.info.itemQuoted.quotePrice
      const offer = this.offer
      const r = ((offer * 100) / v2) - 100
      return r.toFixed()
    }
  },
  watch: {
    info: {
      handler (i) {
        this.fillMonitor(i)
      },
      deep: true
    }
  },
  mounted () {
    this.fillMonitor(this.info)
  },
  methods: {
    fillMonitor (i) {
      if (i.result &&
        i.result[this.position] &&
        i.result[this.position].offer) {
        this.offer = i.result[this.position].offer
        this.lab = i.result[this.position].lab
        this.distributor = this.info[`${this.position}Distributor`] && this.info[`${this.position}Distributor`].name
      }
    },
    fillForm () {
      if (this.info.result && this.info.result[this.position] && !this.form.offer) {
        const offerResult = this.convertCurrencyToMoney(this.info.result[this.position].offer)
        this.form.offer = offerResult
        this.form.distributorId = this.info.result[this.position] && this.info.result[this.position].distributor
        this.form.lab = this.info.result[this.position] && this.info.result[this.position].lab
        this.distributor = this.info[`${this.position}Distributor`] && this.info[`${this.position}Distributor`].name
      }
    },
    convertCurrencyToMoney (v) {
      const offer = v
        .toFixed(4)
        .toString()
        .replace('.', '')
      return Number(offer)
    },
    selectDistributor (item) {
      this.distributor = item.source.name
      this.form.distributorId = item.source._id
    },
    isFieldValid () {
      const offerNumber = this.convertCurrencyToNumber(this.form.offer)
      if (this.form.distributorId && offerNumber > 0) {
        return true
      }
      return false
    },
    async saveResult () {
      if (!this.isFieldValid()) {
        this.$toasted.error('Campo inválido')
        return
      }
      this.status = 'saving'

      const payload = {
        userId: this.$store.getters['Login/GET_USER_ID'],
        eventId: this.$route.params.id,
        itemId: this.info._id,
        distributorId: this.form.distributorId,
        offer: this.form.offer,
        lab: this.form.lab,
        position: this.position
      }

      try {
        await SaveResult(payload)
        const newOffer = this.convertCurrencyToNumber(this.form.offer)
        // this.offer = newOffer
        // this.lab = this.form.lab
        this.$store.commit('Result/UPDATE_RESULT_ITEM', {
          itemId: this.info._id,
          position: this.position,
          distributorId: this.form.distributorId,
          lab: this.form.lab,
          offer: newOffer,
          distributorName: this.distributor
        })

        this.$toasted.success('Item salvo')
      } catch (error) {
        this.$toasted.error('Não foi possível salvar')
      } finally {
        this.status = false
        this.escapeFromEdition()
      }
    },
    async removeResult () {
      this.status = 'removing'

      const payload = {
        quoteId: this.info._id,
        position: this.position,
        userId: this.$store.getters['Login/GET_USER_ID']
      }

      try {
        await this.$store.dispatch('Result/REMOVE_BY_POSITION', payload)
        this.distributor = ''
        this.form.distributorId = null
        this.form.lab = null
        this.form.offer = null
        this.lab = ''
        this.offer = 0

        this.editMode = false

        this.$toasted.success('Resultado removido!')
      } catch (error) {
        this.$toasted.error('Não conseguimos remover esse resultado')
      } finally {
        this.status = false
      }
    },
    convertCurrencyToNumber (v) {
      return v && Number(v
        .toString()
        .replace('.', '')
        .replace(',', '.'))
    },
    enterEditMode () {
      this.fillForm()
      this.editMode = true
    },
    escapeFromEdition () {
      if (!this.status) {
        this.editMode = false
      }
    },
    convertOffer (v) {
      return v / Math.pow(10, this.precision)
    },
    calcTotal (c) {
      const offer = this.convertOffer(c)
      const r = offer * this.info.itemInfo.quantity * this.info.itemInfo.factor
      return r
    },
    calcTotalPerc (v1, v2) {
      const offer = this.convertOffer(v1)
      const r = ((offer * 100) / v2) - 100
      return r.toFixed()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-result/components/column-result/ColumnResult.vue